import React from 'react'
import AvailableCourseCard from './AvailableCourseCard'

const AvailableCourses = () => {
    return (
        <div className='w-full mb-6 md:mb-10'>
            <div className='w-full'>
                <div className='mb-3 sm:mb-4 font-bold text-[#151515] text-lg sm:text-xl leading-[28px] sm:leading-[30px]'>Available Courses</div>
                <AvailableCourseCard />
            </div>
        </div>
    )
}

export default AvailableCourses